// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {

  return request<{
    data: API.CurrentUser;
  }>('/api/admin/getUserInfoByAdminId', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(options as Record<string, string>),
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams) {
  return request<API.Res<API.CurrentUser>>('/api/admin/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(body as Record<string, string>),
  });
}

export async function addAppraisalCategory(options?: { [key: string]: any }) {
  return request("/api/identityCategory/add", {
    method: 'POST',
    data: options,
  })
}
export async function getAppraisalCategoryList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.AppraisalCategory>>("/api/identityCategory/query", {
    method: 'POST',
    data: options,
  })
}

export async function updateAppraisalCategory(options?: { [key: string]: any }) {
  return request("/api/identityCategory/update", {
    method: 'POST',
    data: options,
  })
}

export async function getUserList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.User>>("/api/user/list/page/vo", {
    method: 'POST',
    data: options,
  })
}

export async function updateUser(options?: { [key: string]: any }) {
  return request("/api/user/updateUserInfo", {
    method: 'POST',
    data: options,
  })
}

export async function getAppraiserList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Appraiser>>("/api/user/list/page/vo", {
    method: 'POST',
    data: {
      isAppraiser: 1,
      ...options,
    },
  })
}

export async function setAppraiser(options?: { [key: string]: any }) {
  return request("/api/user/setAppraiser", {
    method: 'POST',
    data: options,
  })
}

export async function getTopicList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Topic>>("/api/topic/list/page", {
    method: 'POST',
    data: options,
  })
}
export async function updateTopic(options?: { [key: string]: any }) {
  return request("/api/topic/updateTopic", {
    method: 'POST',
    data: options,
  })
}
export async function addTopic(options?: { [key: string]: any }) {
  return request("/api/topic/addTopic", {
    method: 'POST',
    data: options,
  })
}
export async function deleteTopic(options?: { [key: string]: any }) {
  return request("/api/topic/delTopic", {
    method: 'POST',
    data: options,
  })
}
export async function getProductList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Product>>("/api/product/list/page/vo", {
    method: 'POST',
    data: options,
  })
}

export async function updateProduct(options?: { [key: string]: any }) {
  return request("/api/product/updateProduct", {
    method: 'POST',
    data: options,
  })
}

export async function addProduct(options?: { [key: string]: any }) {
  return request("/api/product/publish", {
    method: 'POST',
    data: options,
  })
}

export async function deleteProduct(options?: { [key: string]: any }) {
  return request("/api/product/del", {
    method: 'POST',
    data: options,
  })
}

export async function getProductDetail(options?: { [key: string]: any }) {
  return request<API.Res<API.Product>>("/api/product/getDetail", {
    method: 'POST',
    data: options,
  })
}

export async function getProductCategoryList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.ProductCategory>>("/api/categories/list/page", {
    method: 'POST',
    data: options,
  })
}
export async function addProductCategory(options?: { [key: string]: any }) {
  return request("/api/categories/add", {
    method: 'POST',
    data: options,
  })
}
export async function updateProductCategory(options?: { [key: string]: any }) {
  return request("/api/categories/updateCateGery", {
    method: 'POST',
    data: options,
  })
}
export async function deleteProductCategory(options?: { [key: string]: any }) {
  return request("/api/categories/delCateGery", {
    method: 'POST',
    data: options,
  })
}
export async function getSystemManagerList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.SystemManager>>("/api/admin/list/page/vo", {
    method: 'POST',
    data: options,
  })
}
export async function addSystemManager(options?: { [key: string]: any }) {
  return request("/api/admin/addAdmin", {
    method: 'POST',
    data: options,
  })
}
export async function updateSystemManager(options?: { [key: string]: any }) {
  return request("/api/admin/updateAdminInfo", {
    method: 'POST',
    data: options,
  })
}
export async function deleteSystemManager(options?: { [key: string]: any }) {
  return request("/api/admin/logicDelById", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(options as Record<string, string>),
  })
}
export async function getRoleList(options?: { [key: string]: any }) {
  return request<API.Res<API.Role[]>>("/api/role/getAllRoles", {
    method: 'POST',
    data: options,
  })
}
export async function addRole(options?: { [key: string]: any }) {
  return request("/api/role/addRole", {
    method: 'POST',
    data: options,
  })
}

export async function deleteRole(options?: { [key: string]: any }) {
  return request("/api/role/delById", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(options as Record<string, string>),
  })
}

export async function getOrderList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Order>>("/api/order/list/page", {
    method: 'POST',
    data: options,
  })
}

export async function getTransactionList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Transaction>>("/api/transactionDetails/list/page/vo", {
    method: 'POST',
    data: options,
  })
}

export async function editManagerPermission(options?: { [key: string]: any }) {
  return request("/api/modules/editAdminModules", {
    method: 'POST',
    data: options,
  })
}

export async function getAdminPermission(options?: { [key: string]: any }) {
  return request<API.Res<string>>("/api/modules/getModulesByAdminId", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(options),
  })
}
export async function getAppointList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Appoint>>("/api/appointment/list/page/vo", {
    method: 'POST',
    data: options,
  })
}

export async function aduitAppoint(options?: { [key: string]: any }) {
  return request("/api/appointment/auditAppoint", {
    method: 'POST',
    data: options,
  })
}

export async function getPermissionLog(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.PermissionLog>>("/api/permissionHistory/list/page", {
    method: "POST",
    data: options
  })
}

export async function getUserAuthList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.UserAuth>>("/api/userAuth/list/page", {
    method: "POST",
    data: options
  })
}

export async function editRole(options?: { [key: string]: any }) {
  return request("/api/role/updateById", {
    method: "POST",
    data: options
  })
}
export async function getIdentityCategoryList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.IdentityCategory>>("/api/identityCategory/query", {
    method: "POST",
    data: options
  })
}
export async function addIdentityCategory(options?: { [key: string]: any }) {
  return request("/api/identityCategory/add", {
    method: "POST",
    data: options
  })
}
export async function delIdentityCategory(options?: { [key: string]: any }) {
  return request("/api/identityCategory/delete", {
    method: "POST",
    data: options
  })
}

export async function editIdentityCategory(options?: { [key: string]: any }) {
  return request("/api/identityCategory/update", {
    method: "POST",
    data: options
  })
}

export async function getIdentityHistoryList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.IdentityLog>>("/api/identifyRecord/queryPage", {
    method: "POST",
    data: options
  })
}

export async function startIdentity(options?: { [key: string]: any }) {
  return request("/api/identifyRecord/updateIdentifyStatus", {
    method: "POST",
    data: options
  })
}

export async function identifyProduct(options?: { [key: string]: any }) {
  return request("/api/identifyRecord/identifyProduct", {
    method: "POST",
    data: options
  })
}

export async function getAddressList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Address>>("/api/address/list/page/vo", {
    method: "POST",
    data: options
  })
}

export async function getAppointCommentList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.AppiontComment>>("/api/comment/list/page/vo", {
    method: "POST",
    data: options
  })
}

export async function addOrderReview(options?: { [key: string]: any }) {
  return request("/api/review/addReview", {
    method: "POST",
    data: options
  })
}

export async function auditProduct(options?: { [key: string]: any }) {
  return request("/api/product/auditProduct", {
    method: "POST",
    data: options
  })
}
export async function getOrderReviewList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.OrderComment>>("/api/review/list/page", {
    method: "POST",
    data: options
  })
}

export async function getGuidePageList(options?: { [key: string]: any }) {
  return request<API.Res<API.GuidePage[]>>("/api/identityHomeGuide/queryAllGuidePage", {
    method: "POST",
    data: options
  })
}

export async function addGuidePage(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/addGuideTab", {
    method: "POST",
    data: options
  })
}
export async function updateGuidePage(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/updateGuideTab", {
    method: "POST",
    data: options
  })
}

export async function deleteGuidePage(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/delGuideTab", {
    method: "POST",
    data: options
  })
}

export async function getGuideMdeiaList(options?: { [key: string]: any }) {
  return request<API.Res<API.GuideMedia[]>>("/api/identityHomeGuide/queryAllGuideMediaById", {
    method: "POST",
    data: options
  })
}
export async function addGuideMedia(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/addGuideMedia", {
    method: "POST",
    data: options
  })
}
export async function updateGuideMedia(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/updateGuideMedia", {
    method: "POST",
    data: options
  })
}
export async function deleteGuideMedia(options?: { [key: string]: any }) {
  return request("/api/identityHomeGuide/delGuideMedia", {
    method: "POST",
    data: options
  })
}

export async function getWithdrawRecord(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.WithdrawRecord>>("/api/withdraw/list/page/vo", {
    method: "POST",
    data: options
  })
}

export async function auditWithdraw(params?: { [key: string]: any }) {
  return request("/api/withdraw/audit", {
    method: "POST",
    data: params
  })
}

export async function setHotProduct(options?: { [key: string]: any }) {
  return request("/api/product/setHotProduct", {
    method: "POST",
    data: options
  })
}

export async function getReservePriceList(options?: { [key: string]: any }) {
  return request<API.Res<API.ReservePrice[]>>("/api/appointmentIdentityPrice/list", {
    method: "POST",
    data: options
  })
}

export async function updateReservePrice(options?: { [key: string]: any }) {
  return request("/api/appointmentIdentityPrice/updateById", {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: new URLSearchParams(options as Record<string, string>),
  })
}

export async function getBrandReservationList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.BrandReservation>>("/api/appointmentBrand/list/page", {
    method: "POST",
    data: options
  })
}

export async function addBrandReservation(options?: { [key: string]: any }) {
  return request("/api/appointmentBrand/addAppointmentBrand", {
    method: "POST",
    data: options
  })
}

export async function updateBrandReservation(options?: { [key: string]: any }) {
  return request("/api/appointmentBrand/updateAppointmentBrand", {
    method: "POST",
    data: options
  })
}

export async function deleteBrandReservation(options?: { [key: string]: any }) {
  return request("/api/appointmentBrand/delAppointmentBrandById", {
    method: "POST",
    data: options
  })
}

export async function getCouponList(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.Coupon>>("/api/coupon/list/page", {
    method: "POST",
    data: options
  })
}

export async function addCoupon(options?: { [key: string]: any }) {
  return request("/api/coupon/addCoupon", {
    method: "POST",
    data: options
  })
}

export async function getCouponRecordPage(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.CouponRedemptionRecord>>("/api/coupon/list/getRecordPage", {
    method: "POST",
    data: options
  })
}

export async function getCouponUseRecordPage(options?: { [key: string]: any }) {
  return request<API.PageInfo<API.CouponRedemptionRecord>>("/api/coupon/list/useRecordPage", {
    method: "POST",
    data: options
  })
}